<template>
    <Menu
        as="div"
        class="relative">
        <MenuButton class="relative flex items-center gap-4 text-sm focus:outline-hidden cursor-pointer">
            <slot name="trigger" />
        </MenuButton>
        <Transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95">
            <MenuItems
                class="absolute z-10 mt-2 min-w-48 origin-top-right rounded-md bg-white dark:bg-gray-800 py-1 shadow-lg
                ring-1 ring-gray-900/5 focus:outline-hidden"
                :class="{
                    'left-0': position === 'left',
                    'right-0': position === 'right',
                    'left-1/2': position === 'center'
                }">
                <slot />
            </MenuItems>
        </Transition>
    </Menu>
</template>

<script setup>
defineProps({
    position: {
        type: String,
        default: 'right',
        description: 'center || left || right'
    }
})
</script>
